module.exports = __webpack_public_path__ + "static/media/avatar.fa5b5ca3.svg";